import React from 'react'
import { Head } from '@inertiajs/react'
import { AuthPageShell } from '@/components/admin/atoms/layout/AuthPageShell'
import { Stack } from '@/components/admin/atoms/layout/Stack'
import { Surface } from '@/components/admin/atoms/layout/Surface'
import { Padding } from '@/components/admin/atoms/layout/Padding'
import { Heading } from '@/components/admin/atoms/typography/Heading'
import { Text } from '@/components/admin/atoms/typography/Text'
import { Muted } from '@/components/admin/atoms/typography/Muted'
import { AppLogo } from '@/components/admin/atoms/feedback/AppLogo'
import { AlertBanner } from '@/components/admin/atoms/feedback/AlertBanner'
import { Form } from '@/components/admin/atoms/inputs/Form'
import { TextInput } from '@/components/admin/atoms/inputs/TextInput'
import { ActionButton } from '@/components/admin/atoms/actions/ActionButton'
import { CheckboxInput } from '@/components/admin/atoms/inputs/CheckboxInput'
import { FormField } from '@/components/admin/molecules/form/FormField'
import { useLoginVM } from './Login.vm'

const Login: React.FC = () => {
  const vm = useLoginVM()

  return (
    <>
      <Head title="Login" />
      <AuthPageShell>
        <Stack gap="8" align="center">
          <Stack gap="2" align="center">
            <AppLogo />
            <Heading level={1}>
              Code<Text as="span" size="inherit" color="primary" weight="normal">of</Text>Mario
            </Heading>
            <Muted>Sign in to your account</Muted>
          </Stack>

          <Surface variant="card" radius="lg">
            <Padding all="6">
              <Form onSubmit={vm.handleSubmit}>
                <Stack gap="4">
                  {vm.error && (
                    <AlertBanner variant="error">{vm.error}</AlertBanner>
                  )}
                  <FormField label="Email" htmlFor="email">
                    <TextInput
                      id="email"
                      type="email"
                      value={vm.email}
                      onChange={vm.setEmail}
                      placeholder="you@example.com"
                    />
                  </FormField>
                  <FormField label="Password" htmlFor="password">
                    <TextInput
                      id="password"
                      type="password"
                      value={vm.password}
                      onChange={vm.setPassword}
                      placeholder="••••••••"
                    />
                  </FormField>
                  <CheckboxInput
                    checked={vm.rememberMe}
                    onChange={vm.setRememberMe}
                    label="Remember me"
                  />
                  <ActionButton type="submit" loading={vm.loading}>
                    Sign in
                  </ActionButton>
                </Stack>
              </Form>
            </Padding>
          </Surface>
        </Stack>
      </AuthPageShell>
    </>
  )
}

export default Login
